<template>
  <div>
    <div class="f-search-block">
      <div class="search-items">
        <div class="field-item">
          <div class="field-item-control">
            <el-input
              v-model="keyword"
              class="name-mobile-input"
              placeholder="请输入内容"
            >
              <el-select
                slot="prepend"
                v-model="keywordType"
                style="width: 120px"
                placeholder="请选择"
                size="small"
              >
                <el-option
                  v-for="(item, index) in keyWordMap"
                  :key="index"
                  :label="item"
                  :value="index"
                />
              </el-select>
            </el-input>
          </div>
        </div>
        <div class="search-btns">
          <el-button
            type="primary"
            @click="haddleSearch"
          >
            查询
          </el-button>
          <el-button
            type="primary"
            @click="onReset"
          >
            重置
          </el-button>
        </div>
      </div>
    </div>
    <div class="f-toolbar-block">
      <el-button
        type="primary"
        @click="createGroup"
      >
        新建群组
      </el-button>
      <el-button
        type="primary"
        @click="departmentVisible = true"
      >
        同步企微部门为群组
      </el-button>
    </div>
    <div class="f-table-block">
      <el-table
        v-loading="loading"
        :data="listData"
        row-key="id"
        default-expand-all
      >
        <el-table-column
          prop="group_name"
          label="群组名称"
        >
          <template slot-scope="scope">
            <div class="inline-title">
              <el-input
                v-if="scope.row.editing"
                v-model="scope.row.group_name"
                placeholder=""
                maxlength="15"
                show-word-limit
                @blur="changeTitle(scope.row)"
              />
              <span
                v-else
                class="title"
                @click="editTitle(scope.row)"
              >{{
                scope.row.group_name
              }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="group_code"
          label="群组编码"
          width="120"
        />
        <el-table-column
          v-if="searching"
          prop="path_name"
          label="群组路径"
        />
        <el-table-column
          prop="desc"
          label="描述"
          width="auto"
        />
        <!-- <el-table-column
          prop="account_id"
          label="已关联店铺数"
          width="120"
        /> -->

        <el-table-column
          label="操作"
          width="220px"
        >
          <template
            v-if="scope.row.is_wechat !== 1"
            slot-scope="scope"
          >
            <el-button
              type="text"
              size="small"
              @click="handleAdd(scope.row)"
            >
              添加子群组
            </el-button>
            <el-button
              type="text"
              size="small"
              @click="handleEdit(scope.row)"
            >
              编辑
            </el-button>
            <el-button
              type="text"
              size="small"
              @click="handleDel(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 编辑组件 -->
    <SpEditGroup
      v-model="editGroupVisible"
      :group-id="editGroupId"
      :type="groupType"
      @submitGroup="submitGroup"
    />

    <!-- 同步企微部门为群组 -->
    <SpDepartmentSelect
      v-model="departmentVisible"
      @submitDepartment="submitDepartment"
    />

    <!-- 同步企微 -->
    <SpecifiedGroups
      v-model="specifiedGroups"
      @submitSpccifiedGroups="submitSpccifiedGroups"
    />
  </div>
</template>

<script>
import SpecifiedGroups from './comps/specifiedGroups.vue'
export default {
  components: {
    SpecifiedGroups
  },
  data () {
    const keyWordMap = {
      'group_name': '群组名称',
      'group_code': '群组编号'
    }
    return {
      departmentVisible: false,
      specifiedGroups: false,
      keyWordMap,
      keywordType: 'group_name',
      keyword: '',
      dataUrl: `${process.env.VUE_APP_BASE_API}/members/member`,
      listData: [],
      params: {},
      total_count: 0,
      loading: false,
      editGroupVisible: false,
      editGroupId: 0,
      editLabelData: {},
      syncLoading: false,
      groupType: 0, //0是创建新群组，1更新群组
      dialogSelectGroupVisible: false,
      syncDepartmentId: '',
      searching: false
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    // 获取列表数据
    async getList () {
      const params = { ...this.params }
      const { keywordType, keyword } = this
      params[keywordType] = keyword
      const data = await this.$api.organization.getGroupsList(params)
      if (data) {
        const initData = (list) => {
          list.forEach((v) => {
            v.editing = false
            if (v.children) {
              initData(v.children)
            }
          })
        }
        initData(data.list)
        this.listData = data.list
        this.total_count = data.total_count
      }
    },
    // 创建
    createGroup () {
      this.groupType = 0
      this.editGroupVisible = true
      this.editGroupId = 0
    },
    // 添加子群组
    handleAdd (row) {
      this.groupType = 0
      this.editGroupVisible = true
      this.editGroupId = row.id
    },
    // 编辑
    handleEdit (row) {
      this.groupType = 1
      this.editGroupVisible = true
      this.editLabelData = row
      this.editGroupId = row.id
    },
    // 删除
    handleDel (row) {
      this.$confirm('此操作将永久删除该群组，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          const data = await this.$api.organization.deleteGroups(row.id)
          if (data && data.status) {
            this.$message.success('删除成功')
            this.haddleSearch()
          } else {
            this.$message.error('删除失败')
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 查询
    haddleSearch () {
      if (this.keyword) {
        this.searching = true
      } else {
        this.searching = false
      }
      this.getList()
    },
    // 新建群组
    submitGroup () {
      this.getList()
      this.editGroupVisible = false
    },

    // 编辑群组名称
    editTitle (row) {
      row.editing = true
    },

    // 编辑名称
    async changeTitle (row) {
      row.editing = false
      const data = await this.$api.organization.updateGroups(row.id, {
        group_name: row.group_name
      })
      if (data) {
        this.$message.success('编辑成功')
      } else {
        this.$message.error('编辑失败')
        this.haddleSearch()
      }
    },

    // 同步企微
    submitDepartment (ids) {
      if (ids && ids.length > 0) {
        this.departmentVisible = false
        this.specifiedGroups = true
        this.syncDepartmentId = ids
      } else {
        this.$message.error('请选择需要同步的企微')
      }
    },

    async submitSpccifiedGroups (groupId) {
      const data = await this.$api.organization.syncWechatGroups({
        group_id: groupId.join(),
        wechat_group_id: this.syncDepartmentId
      })
      if (data) {
        if (data.status) {
          this.$message.success('同步成功')
        } else if (!data.status && !data.error) {
          this.$message.error('同步失败')
        }
        if (data.error && data.error.length > 0) {
          let errorData = data.error.join(',')
          this.$alert(`${errorData} 已同步，无需重复同步`, '提示', {
            confirmButtonText: '确定'
          })
        }
        this.specifiedGroups = false
        this.haddleSearch()
      }
    },

    // 重置
    onReset () {
      this.keywordType = 'group_name'
      this.keyword = ''
      this.haddleSearch()
    }
  }
}
</script>

<style lang="scss" scoped>
.tooltip {
  cursor: pointer;
}

::v-deep {
  .el-table__cell {
    .cell {
      display: flex;
      align-items: center;
    }
  }
}

.inline-title {
  display: flex;
  align-items: center;
  .title {
    display: inline-block;
    min-width: 120px;
    max-width: 220px;
    // line-height: 23px;
    cursor: pointer;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
